import { render, staticRenderFns } from "./Jglist.vue?vue&type=template&id=14d04a3f&scoped=true"
import script from "./Jglist.vue?vue&type=script&lang=js"
export * from "./Jglist.vue?vue&type=script&lang=js"
import style0 from "./Jglist.vue?vue&type=style&index=0&id=14d04a3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d04a3f",
  null
  
)

export default component.exports